import { BookingMethod, VenueModel, VenueSearchResult, WorkspaceSearchResult } from "Services/API/API";
import React, { useRef } from "react";
import { Card, CardProps } from "Components/Card";
import classNames from "classnames";
import classes from "./styles.module.scss";
import { HealthAndSafetyBadge } from "Components/HealthAndSafetyBadge";
import { InstantBookBadge } from "Components/InstantBookBadge";
import { ImageSwiper } from "Components/ImageSwiper";
import { FavoriteWidget } from "Components/Favorite/FavoriteWidget";
import { Star } from "Components/Icons";
import { Color } from "Components/Favorite/FavoriteButton";
import { Button } from "Components/ReactstrapSlim";

interface WorkspaceCardProps extends CardProps {
   venue: VenueSearchResult | VenueModel;
   workspace: WorkspaceSearchResult;
   className?: string;
   onWorkHereClick?: () => void;
   container?: HTMLElement | string;
}

const WorkspaceCard: React.FC<WorkspaceCardProps> = ({ children, venue, workspace, className, container, onWorkHereClick, ...rest }) => {
   const imageRef = useRef<HTMLDivElement>(null);
   const hasHealthAndSafetyPolicy = venue instanceof VenueSearchResult ? venue.hasHealthAndSafetyPolicy : venue.healthAndSafetyPolicy;
   const venueId = venue instanceof VenueSearchResult ? venue.venueId : venue.id;
   const modalContainer = !!container && container instanceof HTMLElement ? container : document.body;

   const onWorkHereInternal = (ev: React.SyntheticEvent) => {
      ev.stopPropagation();
      onWorkHereClick && onWorkHereClick();
   }

   const toVenueName = () => {
      return onWorkHereClick 
         ? <a href={venue.url} target="_blank" onClick={e => e.stopPropagation()}>{venue.name}</a>
         : venue.name;
   }

   return <Card className={classNames(classes.card, className)} {...rest} ref={imageRef}>
      <div className={classes.image}>
         <div className={classes.badges}>
            <div className={classes.badgesBlock}>
               {hasHealthAndSafetyPolicy && <HealthAndSafetyBadge container={modalContainer} />}
               {venue.defaultBookingMethodHourly == BookingMethod.BookItNow && <InstantBookBadge container={modalContainer} />}
            </div>
            <div className={classes.badgesBlock}>
               <FavoriteWidget color={Color.white} venueId={venueId} workspaceId={workspace.id} container={container} />
            </div>
         </div>
         <div>{children}</div>
         <ImageSwiper imageUrls={venue.imageUrls || []} inCard />
      </div>
      <div className={classes.content}>
         <div className={classes.priceAndRating}>
            <div className={classes.price}>{workspace.priceAmount}{workspace.priceDescription}</div>
            <div className={classes.rating}>
               {
                  workspace.averageRating && workspace.averageRating > 0
                     ? <>
                        <Star className={classes.star} />
                        {workspace.averageRating.toFixed(1)}
                     </>
                     : null
               }
            </div>
         </div>
         <div className={classes.spaceType}>{workspace.spaceTypeFormatted}</div>
         <div className={classes.venueName} title={venue.name}>{toVenueName()}</div>
         <div className={classes.venueAddress} title={venue.address}>{venue.address}</div>
         { onWorkHereClick && <div className={classNames(classes.actions)}>
            <Button className={classNames(classes.cta)} color="primary" size="sm" onClick={onWorkHereInternal}>Work Here</Button>
         </div> }
      </div>
   </Card>
}

export default WorkspaceCard;